module.exports = __webpack_public_path__ + "static/media/rafflesmarina_2.7653f744.jpg";